export const WHITE = '#FFFFFF';
export const BLACK = '#000000';

export type hex = string;
export type rgb = [number, number, number];

export const hexToRGB = (hexColor: hex): rgb => {
  const r = parseInt(hexColor.substr(1, 2), 16);
  const g = parseInt(hexColor.substr(3, 2), 16);
  const b = parseInt(hexColor.substr(5, 2), 16);
  return [r, g, b];
};

export const rgbToHex = (rgbColor: rgb): hex => {
  return '#' + rgbColor.map((value) => value.toString(16).padStart(2, '0')).join('');
};

export const getContrastColor = (hexColor: hex): hex => {
  const [r, g, b] = hexToRGB(hexColor);
  const yiq = (r * 299 + g * 587 + b * 114) / 1000;
  return yiq >= 128 ? BLACK : WHITE;
};

export const mixColors = (hexColor1: hex, hexColor2: hex, ratio: number): hex => {
  const rgbColor1 = hexToRGB(hexColor1);
  const rgbColor2 = hexToRGB(hexColor2);

  const rgbMixedColor = rgbColor1.map((_, index) => {
    return Math.floor(rgbColor1[index] * ratio + rgbColor2[index] * (1 - ratio));
  }) as rgb;

  return rgbToHex(rgbMixedColor);
};

export const darken = (hexColor: hex, amount = 0.2): hex => {
  return mixColors(BLACK, hexColor, amount);
};

export const lighten = (hexColor: hex, amount = 0.2): hex => {
  return mixColors(WHITE, hexColor, amount);
};
